export const MENU_HERO_GRADIENT_OVERLAY =
  'linear-gradient(90deg, rgba(0, 0, 0, 0.56) 24.1%, rgba(196, 196, 196, 0) 45.59%)';
